/**
 * Chrome classes for Professor Ka's frames. GEOMETRY is not here — the tile's
 * box, radius, ring width and art size all ramp with the DS scale and come from
 * `professorKaTileMetrics` instead, so nothing in this file can pin a rendered
 * size to a phone.
 */

/**
 * The floating chat-entry tile (Figma `130:4865`): an amber-ringed square the
 * calibrated composition fills flush to the border box (see
 * `KA_TILE_ART_RATIO`). `overflow-hidden` clips the −border-seated artwork to
 * the ring's radius.
 */
export const kaTileClass = 'overflow-hidden border-amber-400 bg-amber-50';

/**
 * The single chat avatar's frame — a rounded, elevated square that Ka fills
 * edge to edge (no crop, no ring; the conversation is busy enough).
 */
export const kaChatAvatarClass =
  'flex flex-none rounded-xl shadow-[0px_10px_15px_-3px_rgba(0,0,0,0.1),0px_4px_6px_-2px_rgba(0,0,0,0.05)]';

/**
 * The same tile when the host injects art that brings its own card (the
 * floating Rive — see `ProfessorKaTileProps.renderArt`): no ring, no fill and
 * NO clip, so Ka can lean out past his card when he peeks.
 */
export const kaTileArtSlotClass = 'overflow-visible';
